// src/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const TEST_COLOR = '#f709dd'

const ALV_PURPLE            = '#951B81'
const ALV_BLUE              = '#AE83AE' // PT: '#79c1d9'
const ALV_BLUE_DARK         = '#8E6A8E'
const CAPPOCCINO_WHITE      = '#f2edda'
const LIGHT_GRAY            = '#a0a0a0'
const DARK_GRAY             = '#6b6b6b'
const CONTENT_BACKGROUND    = '#FAFAFA'
const LISTHEADER_BACKGROUND = '#FBFBF9'
const EXCEL_GREEN           = '#1D6F42'

const GRAY_COLOR_THEME =  
{
    // General
    logo:                       ALV_PURPLE, // ALV logo color
    contentBackground:          '#ffffff',
    generalCheckbox:            ALV_BLUE,
    generalDropdownSelected:    ALV_BLUE,
    warning:                    '#F1D442',
    error:                      '#90100f',
    selectedChip:               '#d3cdb1',
    subtitleGray:               '#999999',

    // Header
    headerBackground:                   '#ffffff',
    headerExtensionAboveContent:        '#898989',
    headerExtensionAboveNavigation:     DARK_GRAY,
    headerReportFileImportFont:         '#ffffff',
    headerReportFileImportBackground:   DARK_GRAY,

    // Icons & Buttons & Datepicker
    iconSave:               ALV_BLUE,             
    iconStandard:           ALV_BLUE,
    iconContract:           ALV_BLUE_DARK,
    iconCancel:             LIGHT_GRAY,    
    iconCancelEditForm:     '#a0a0a0',
    iconDelete:             '#D0D0D0',
    iconContextHelp:        '#D4C4A8',          
    buttonStandard:         ALV_BLUE,
    buttonCancel:           LIGHT_GRAY,
    switchStandard:         ALV_BLUE,
    tooltipBackground:      DARK_GRAY,
    datePicker:             LIGHT_GRAY,
    breadcrumbIcon:         '#ffffff',
    standardBrownIcon:      '#C0A691',

    // Navigation
    navigationBackground:               '#424242',
    navigationListBackground:           '#424242',
    navigationBackgroundActiveGroup:    '#adadad', 
    navigationHoverItem:                DARK_GRAY,
    navigationItemsIconsActive:         '#0072ef',
    navigationSubitemIcon:              '#000000',

    // List Page
    listPageBackground:                 '#ffffff',
    listPageHeadlineBackground:         '#ffffff',
    listPageFilterBackground:           '#ffffff',
    listPageListBackground:             '#ffffff',
    listPageDataTableBackground:        '#ffffff',
    listPageHeadersText:                '#000000',
    listPageHeadersBackground:          LIGHT_GRAY,
    listPageHoverItem:                  '#dadada',
    listPageTopSlot:                    '#ffffff',
    pagination:                         ALV_BLUE,
    expandPanelBackground:              '#ffffff',

    // Edit Page
    editPageBackground:             '#ffffff',
    editPageHeadlineBackground:     '#ffffff',  
    defaultImageEditPage:           '#dadada',

    // Panels
    panelHeaderBackground:                      LIGHT_GRAY,
    panelContentBackground:                     '#ffffff',
    azPersonMetadataPanelHeaderBackground:      LIGHT_GRAY,
    azPersonMetadataPanelContentBackground:     '#ffffff',
    contractSharesPanelHeaderBackground:        LIGHT_GRAY,
    contractSharesPanelContentBackground:       '#ffffff',
    contractWorksPanelHeaderBackground:         LIGHT_GRAY,
    contractWorksPanelContentBackground:        '#ffffff',

    // Dialogs
    dialogStandardHeaderBackground:     '#424242',
    dialogStandardHeadlineText:         '#ffffff',
    dialogStandardText:                 '#000000',
    dialogStandardBackground:           '#ffffff',
    dialogProgressbar:                  ALV_PURPLE,

    // GEMA Test Calculation Dialog
    excelLineBackground:        EXCEL_GREEN,
    excelLineFont:              '#ffffff',
    contractLineBackground:     '#EDEADE',
    contractLineFont:           '#000000',
    resultHeadlineBackground:   ALV_BLUE,
    resultHeadlineFont:         '#000000'
}

const BEIGE_GOLD_COLOR_THEME = 
    {
        // General
        logo:                       ALV_PURPLE,             // ALV logo color
        contentBackground:          CONTENT_BACKGROUND,
        generalCheckbox:            ALV_BLUE,
        generalDropdownSelected:    ALV_BLUE,
        warning:                    '#F1D442',
        error:                      '#90100f',
        selectedChip:               '#d3cdb1',
        subtitleGray:               '#999999',

        // Header
        headerBackground:                   '#ffffff',
        headerExtensionAboveContent:        '#D8D8C0',
        headerExtensionAboveNavigation:     '#BFBF99',
        headerReportFileImportFont:         '#ffffff',
        headerReportFileImportBackground:   DARK_GRAY,

        // Icons & Buttons
        iconSave:           ALV_BLUE,
        iconStandard:       ALV_BLUE,
        iconContract:       ALV_BLUE_DARK,
        chipContractType:   '#7DB5C5',
        iconCancel:         '#FFFFFF',
        iconCancelEditForm: '#a0a0a0',
        iconDelete:         '#D0D0D0',
        iconContextHelp:    '#D4C4A8',
        buttonStandard:     ALV_BLUE,
        buttonCancel:       '#a0a0a0',
        buttonNewEntity:    '#47817D', // PT: '#9C977C',
        switchStandard:     ALV_BLUE,
        tooltipBackground:  '#6b6b6b',
        breadcrumbIcon:     '#ffffff',
        standardBrownIcon:  '#C0A691',

        // Navigation
        navigationBackground:               CAPPOCCINO_WHITE,
        navigationListBackground:           CAPPOCCINO_WHITE,
        navigationBackgroundActiveGroup:    '#d3cdb1',          // REMEMBER THAT COLOR! 
        navigationHoverItem:                '#6b6b6b',
        navigationItemsIconsActive:         '#91268F', // PT: '#91268F',
        navigationSubitemIcon:              '#000000',

        // List Page
        listPageBackground:             CONTENT_BACKGROUND,
        listPageHeadlineBackground:     CONTENT_BACKGROUND,
        listPageFilterBackground:       CONTENT_BACKGROUND,
        listPageListBackground:         CONTENT_BACKGROUND,
        listPageFavouritesBackground:   '#FFF6FF', // PT: '#FFE7FF',
        listPageDataTableBackground:    '#ffffff',
        listPageHeadersText:            '#212121',
        listPageHeadersBackground:      LISTHEADER_BACKGROUND,
        listPageHoverItem:              '#e3decd',
        listPageTopSlot:                CONTENT_BACKGROUND,
        pagination:                     ALV_BLUE,
        expandPanelBackground:          '#F6F5EF',

        // Edit Page
        editPageBackground:             '#ffffff',
        editPageHeadlineBackground:     '#ffffff',  
        defaultImageEditPage:           '#a0a0a0',

        // Panels
        panelHeaderBackground:                      '#EDEADE',
        panelContentBackground:                     '#ffffff',
        azPersonMetadataPanelHeaderBackground:      '#706d64',
        azPersonMetadataPanelContentBackground:     '#f1c27e',
        contractSharesPanelHeaderBackground:        '#706d64',
        contractSharesPanelContentBackground:       '#f1c27e',
        contractWorksPanelHeaderBackground:         '#706d00',
        contractWorksPanelContentBackground:        '#f1c27e',

        // Dialogs
        dialogStandardHeaderBackground:     '#BFBF99',
        dialogStandardHeadlineText:         '#ffffff',
        dialogStandardText:                 '#000000',
        dialogStandardBackground:           '#ffffff',
        dialogProgressbar:                  ALV_PURPLE,

        // GEMA Test Calculation Dialog
        excelLineChip:          EXCEL_GREEN,
        excelLineText:          '#ffffff',
        contractLineChip:       '#EDEADE',
        contractLineText:       '#000000',
        resultHeadlineChip:     ALV_BLUE,
        resultHeadlineText:     '#000000',
        errorLineChip:          '#90100f',
        errorLineText:          '#ffffff'
    }

export default new Vuetify({
    theme: {        
        themes: {            
            light: BEIGE_GOLD_COLOR_THEME
        },
        options: {
            customProperties: true
        }
    },
    icons: {
        iconfont: "md"
        // iconfont: "mdiSvg"
    }
})